export const LOADING_ALLOCATION = "LOADING_ALLOCATION";
export const GET_ALLOCATION_LIST = "GET_ALLOCATION_LIST";
export const ADD_ALLOCATION = "ADD_ALLOCATION";
export const REMOVE_ALLOCATION = "REMOVE_ALLOCATION";
export const UPDATE_ALLOCATION = "UPDATE_ALLOCATION";
export const GET_ALLOCATION_ID = "GET_ALLOCATION_ID";
export const GET_PAYROLL_LIST = "GET_PAYROLL_LIST";
export const ADD_PAYROLL = "ADD_PAYROLL";
export const EXPORT_PAYROLL = "EXPORT_PAYROLL";
export const IMPORT_ALLOCATION = "IMPORT_ALLOCATION";
export const GET_EMPLOYEE_PAYROLL = "GET_EMPLOYEE_PAYROLL";